import React from "react"
import { styled } from "themes"
import { Link } from "gatsby"

export const Section = styled.section`
  width: 100%;
  height: 100%;
`

export const Container = styled((props: any) => <Link {...props} />)`
  position: relative;
  cursor: pointer;
  display: block;
  width: 100%;
  height: 100%;
`

export const Thumbnail = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  &::before {
    background: rgb(0, 0, 0, 0.2);
    border-radius: 8px;
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
  }
  > img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
    object-position: center;
  }
`

export const Title = styled.h3`
  position: absolute;
  left: 8px;
  bottom: 8px;
  color: ${({ theme }) => theme.color.white};
  margin-bottom: 0;
  max-width: 96px;
  font-size: 14px;
  line-height: 14px;
  font-weight: bold;
  &:hover {
    text-decoration: underline;
  }
`

export const Category = styled.div`
  position: absolute;
  right: 8px;
  top: 8px;
  padding: 2px 6px;
  font-size: 8px;
  border-radius: 4px;
  background: ${({ theme }) => theme.color.white};
  color: #868686;
`
